import { getLocationHref } from '@core-ui/url-helper';
import { BuildProductLinkParams, GridParams, QueryParams } from './types';

const buildGridQueryParam = ({
  productGridSource,
  cardIndex,
  totalCount,
  pageIndex,
}: GridParams): string =>
  (productGridSource && pageIndex
    ? `grid=${productGridSource}_${cardIndex}_${totalCount}_${parseInt(
      pageIndex,
      10
    ) + 1}`
    : '');

const safelyEncodeURIParam = (param: string): string => {
  const nonURICodePercentageSigns = new RegExp('%(?![0-9A-Fa-f]{2})', 'g');
  const sanitizedPercentageSigns = param.replace(
    nonURICodePercentageSigns,
    '%25'
  );
  return encodeURIComponent(decodeURIComponent(sanitizedPercentageSigns));
};

const convertParamsToStrings = (queryParamObj: QueryParams): Array<string> =>
  Object.entries(queryParamObj).map(([key, value]) =>
    (value ? `${key}=${safelyEncodeURIParam(value)}` : '')
  );

const buildProductLink = ({
  grid = {},
  additionalQueryParams,
  ...otherParams
}: BuildProductLinkParams): string => {
  const gridParamString = buildGridQueryParam(grid);
  const otherParamsAsStrings = convertParamsToStrings(otherParams);

  const fullQueryString = [
    ...otherParamsAsStrings,
    gridParamString,
    additionalQueryParams,
  ]
    .filter(Boolean)
    .join('&');

  const productPageUrl = new URL('/browse/product.do', getLocationHref());

  return `${productPageUrl}?${fullQueryString}`;
};

export default buildProductLink;
